// eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-imports-ts
import { Component, Host, Prop, State, h, Env } from '@stencil/core';

import { getBaseUrl } from '../../utils';

@Component({
    tag: 'bam-compliance',
    styleUrl: 'bam-compliance.css',
    shadow: false,
})
export class BamCompliance {
    // props
    @Prop() location = '';
    @Prop() countryCode = '';
    @Prop() devMode = false;

    // state
    @State() termsText: string;

    connectedCallback() {
        if (Env.BAM_HYDRATE !== 'true') {
            this.fetchTermsText();
        }
    }

    async componentWillLoad() {
        if (Env.BAM_HYDRATE === 'true') {
            await this.fetchTermsText();
        } else {
            this.fetchTermsText();
        }
    }

    async fetchTermsText() {
        try {
            let url = getBaseUrl(this.devMode) + '/v1/auxiliary/terms';
            const query = [];

            if (this.location) {
                query.push(`location=${this.location}`);
            }
            if (this.countryCode) {
                query.push(`country_code=${this.countryCode}`);
            }
            if (query.length) {
                url += '?' + query.join('&');
            }

            const res = await fetch(url);
            const response = await res.json();

            if (response?.full_terms) {
                const fullTerms = response.full_terms;
                this.termsText = fullTerms.replace(/assets\.actionnetwork\.com/g, 'assets.bet-links.com');
            }
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`BAM Error fetching terms text: ${err}`);
        }
    }
    render() {
        return (
            <Host>
                <span class="bam-compliance" innerHTML={this.termsText}></span>
            </Host>
        );
    }
}
